import { getDataMapper, mapField, getObjectId } from "@/shared";

export const mapInventoryBreakingToServer = getDataMapper({
    broken_id: mapField("breaking", getObjectId),
    inventory_id: mapField("inventory", getObjectId),
});
